export default "__VITE_PUBLIC_ASSET__57f91feb__"